import { render, staticRenderFns } from "./_Header-back.vue?vue&type=template&id=2e84a18a&scoped=true&"
import script from "./_Header-back.vue?vue&type=script&lang=js&"
export * from "./_Header-back.vue?vue&type=script&lang=js&"
import style0 from "./_Header-back.vue?vue&type=style&index=0&id=2e84a18a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84a18a",
  null
  
)

export default component.exports